import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconStop = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.75 6.5C3.75 4.98122 4.98122 3.75 6.5 3.75H17.5C19.0188 3.75 20.25 4.98122 20.25 6.5V17.5C20.25 19.0188 19.0188 20.25 17.5 20.25H6.5C4.98122 20.25 3.75 19.0188 3.75 17.5V6.5ZM6.5 5.25C5.80964 5.25 5.25 5.80964 5.25 6.5V17.5C5.25 18.1904 5.80964 18.75 6.5 18.75H17.5C18.1904 18.75 18.75 18.1904 18.75 17.5V6.5C18.75 5.80964 18.1904 5.25 17.5 5.25H6.5Z",
		fill: "currentColor"
	})
});
export { SvgIconStop as ReactComponent };
